var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronUpcomponent = function SvgChevronUpcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "current",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "chevron-up_component_svg__icon chevron-up_component_svg__icon-tabler chevron-up_component_svg__icons-tabler-outline chevron-up_component_svg__icon-tabler-chevron-up",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6 15 6-6 6 6"
  })));
};
export default SvgChevronUpcomponent;